import {z} from 'zod'
import {AccessType} from '../access-types/types'

export const AccessFrequency = z.enum(['weekly', 'monthly'])
export type AccessFrequency = z.infer<typeof AccessFrequency>

export const PlannedAccessUrlParams = z.object({
    id: z.string()
})
export type PlannedAccessUrlParams = z.infer<typeof PlannedAccessUrlParams>

export const PlannedAccesses = z.object({
    accessType: AccessType,
    frequency: AccessFrequency.nullable(),
    numberOfAccesses: z.number().int(),
    sector: z.enum(['outpatient', 'domiciliary']).nullish()
})
export type PlannedAccesses = z.infer<typeof PlannedAccesses>

export const ProjectPlannedAccess = z.object({
    id: z.string().min(1),
    projectId: z.string().min(1),
    treatmentPlan: z.string().nullable(),
    targets: z.string().nullable(),
    additionalNotes: z.string().nullable(),
    plannedAccesses: z.array(PlannedAccesses)
})
export type ProjectPlannedAccess = z.infer<typeof ProjectPlannedAccess>
